package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.ActiveTimer
import fr.manyverse.app.domain.model.EventContent
import fr.manyverse.app.domain.model.EventType
import fr.manyverse.app.domain.repository.GameEventRepository
import fr.manyverse.app.domain.repository.TimerRepository
import fr.manyverse.app.domain.validation.TimerValidator

/**
 * Use case for creating a timer.
 * Validates inputs, creates the timer, and logs a TIMER_STARTED event.
 */
class CreateTimerUseCase(
    private val timerRepository: TimerRepository,
    private val gameEventRepository: GameEventRepository
) {
    suspend operator fun invoke(
        tableId: String,
        durationSeconds: Int,
        targetParticipants: List<String>,
        createdBy: String
    ): Result<ActiveTimer> {
        // Validate inputs
        TimerValidator.validateForCreation(durationSeconds, targetParticipants).onFailure {
            return Result.failure(it)
        }

        // Create the timer
        val timerResult = timerRepository.createTimer(
            tableId = tableId,
            durationSeconds = durationSeconds,
            targetParticipants = targetParticipants,
            createdBy = createdBy
        )

        timerResult.onFailure {
            return Result.failure(it)
        }

        val timer = timerResult.getOrThrow()

        // Record the event in history
        val content = EventContent.TimerStarted(
            timerId = timer.id,
            durationSeconds = durationSeconds
        )

        gameEventRepository.createEvent(
            tableId = tableId,
            type = EventType.TIMER_STARTED,
            triggeredBy = createdBy,
            targetParticipants = targetParticipants,
            content = content
        )

        return Result.success(timer)
    }
}
